import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS_ADMIN } from "@/lib/permisos";
import { AdminHubPage } from "@/features/admin-hub/components/AdminHubPage";

/** Ruta `/admin` · hub con links a todas las secciones administrativas. */
export const Route = createFileRoute("/_authed-tw/admin/")({
  component: () => (
    <PermissionGate permisos={PERMISOS_ADMIN}>
      <AdminHubPage />
    </PermissionGate>
  ),
});
